import { useContext, useEffect, useState } from 'react';
import { Button, Card, CardContent, CardMedia, Container, Grid, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { authContext } from 'helpers/services';
import theme from 'assets';
import { Page } from 'components';


let Login = () => {
    let location = useLocation();

    let authService = useContext(authContext);

    let [isLoading, setLoading] = useState(true);
    let [returnUrl, setReturnUrl] = useState<string | undefined>();
    let [errors, setErrors] = useState<string | undefined>();


    useEffect(() => {
        let prepareReturnUrl = () => {
            if (location.search) {
                let params = new URLSearchParams(location.search);

                let errors = params.get("error");
                if (errors)
                    setErrors(errors);

                let returnUrl = params.get("returnUrl");
                if (returnUrl)
                    setReturnUrl(returnUrl);
            }

            setLoading(false);
        }

        prepareReturnUrl();
    }, [])

    return (
        <>
            {isLoading === false &&
                <Page title='Login' maxWidth='sm'>
                    <Card>
                        <CardContent>
                            <Grid container textAlign='center' alignItems='center'>
                                <Grid item xs={12}>
                                    <Typography variant="h4">ATHENA OMS</Typography>
                                </Grid>
                                <Grid item xs>
                                    <Button
                                        color="primary"
                                        variant="contained"
                                        onClick={async () => await authService.signInWithAd(returnUrl)}
                                    >
                                        Login with Athena Credentials
                                    </Button>
                                </Grid>
                                <Grid item xs>
                                    <CardMedia
                                        sx={{ height: 190 }}
                                        component="img"
                                        src="/images/homepage.jpg"
                                        title="Athena"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography align="justify" color="error">{errors}</Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Page>

            }
        </>
    )
}

export default Login;